// extracted by mini-css-extract-plugin
module.exports = {"content":"_2762d5e6","item":"_3a82fb7a","image":"_412783c8","itemTitle":"_cdb4c7a","deleteNote":"_60da1086","deleteText":"_30e69deb","textArea":"_ad8c44a5","submit":"_2d421adb"};